import { ToolkitFeatureFlag } from '@cko/primitives';
import React from 'react';
import { SkipLinkComponent } from './SkipLink.styles';
export const SkipLink = () => {
  return (
    <ToolkitFeatureFlag flag="v10">
      <SkipLinkComponent href="#main" variant="inline">
        Skip to main content
      </SkipLinkComponent>
    </ToolkitFeatureFlag>
  );
};
